import React, { useEffect } from 'react'
import { Stack, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Button } from '@mui/material'
import moment from 'moment/moment'
import { useState } from 'react'
import ReactHtmlTableToExcel from 'react-html-table-to-excel'
import jsPDF from 'jspdf'
import autoTable from 'jspdf-autotable'
import { Box } from '@mui/system'
import {
  calculateDynamicFormatLandscape,
  calculateDynamicFormatPortrait,
  calculateTotalTableWidth,
  focusElemnt,
  navigation3,
} from '../../../common/helper'
import AppsIcon from '@mui/icons-material/Apps'
import { callAddFontRobotoBold } from '../../../common/font/Roboto-bold'
import { callAddFontRobotoMedium } from '../../../common/font/Roboto-Medium-normal'
import {
  crdeitDrawCellDetail,
  excelHeaderColumn,
  excelHeaderCreditReport,
  lrDetailPdfFooter,
} from './../common/AcountingConstants'
import * as id from './../common/AcountingId'
import FilterAltIcon from '@mui/icons-material/FilterAlt';

const TablePartywiseCreditLimitTransactionReport = ({
  loginData,
  reportData,
  fromDate,
  toDate,
  company,
  StateName,
  city,
  party,
  updateScreen,
  updateModal,
  columns,
  selectedFields, UseFormattedLRinReports
}) => {
  const [state, setState] = useState({
    generatePDF: false,
    load: false,
  })
  const { generatePDF, load } = { ...state }
  const [showTable, setShowTable] = useState(true)
  const [tableData, setTableData] = useState([])
  const currentDateTime = moment(window.getTime ? window.getTime() : new Date()).format('DD-MMM-YYYY HH:mm');
  const [searchData, setSearchData] = useState({
    PartyName: '',
    LRNO: '',
    FormattedLRNO: '',
    BookingDateTime: '',
    SourceCity: '',
    DestinationCity: '',
    ConsignmentType: '',
    Collection: '',
    CartageAmount: '',
    Commission: "",
    FreightComm: '',
    ValuationComm: '',
    CartageComm: '',
    TranType: '',
    TransDate: '',
    OpeningBalance: '',
    Amount: '',
    ClosingBalance: '',
  })

  useEffect(() => {
    setTableData(reportData)
  }, [reportData])
  useEffect(() => {
    let fiterData = reportData.filter((val) =>
      (searchData?.PartyName === "" || (val?.PartyName && val?.PartyName?.toLocaleLowerCase().includes(searchData?.PartyName?.toLocaleLowerCase()))) &&
      (searchData?.LRNO === "" || (val?.LRNO && val?.LRNO?.toLocaleLowerCase().includes(searchData?.LRNO?.toLocaleLowerCase()))) &&
      (searchData?.FormattedLRNO === "" || (val?.FormattedLRNO && val?.FormattedLRNO?.toLocaleLowerCase().includes(searchData?.FormattedLRNO?.toLocaleLowerCase()))) &&
      (searchData?.BookingDateTime === "" || (val?.BookingDateTime && val?.BookingDateTime?.toLocaleLowerCase().includes(searchData?.BookingDateTime?.toLocaleLowerCase()))) &&
      (searchData?.SourceCity === "" || (val?.SourceCity && val?.SourceCity?.toLocaleLowerCase().includes(searchData?.SourceCity?.toLocaleLowerCase()))) &&
      (searchData?.DestinationCity === "" || (val?.DestinationCity && val?.DestinationCity?.toLocaleLowerCase().includes(searchData?.DestinationCity?.toLocaleLowerCase()))) &&
      (searchData?.ConsignmentType === "" || (val?.ConsignmentType && val?.ConsignmentType?.toLocaleLowerCase().includes(searchData?.ConsignmentType?.toLocaleLowerCase()))) &&
      (searchData?.Collection === "" || (val?.Collection && val?.Collection.toString().includes(searchData?.Collection))) &&
      (searchData?.CartageAmount === "" || (val?.CartageAmount && val?.CartageAmount?.toString().includes(searchData?.CartageAmount))) &&
      (searchData?.Commission === "" || (val?.Commission && val?.Commission?.toString().includes(searchData?.Commission))) &&
      (searchData?.FreightComm === "" || (val?.FreightComm && val?.FreightComm?.toString().includes(searchData?.FreightComm))) &&
      (searchData?.ValuationComm === "" || (val?.ValuationComm && val?.ValuationComm?.toString().includes(searchData?.ValuationComm))) &&
      (searchData?.CartageComm === "" || (val?.CartageComm && val?.CartageComm?.toString().includes(searchData?.CartageComm))) &&
      (searchData?.TranType === "" || (val?.TranType && val?.TranType?.toLocaleLowerCase().includes(searchData?.TranType?.toLocaleLowerCase()))) &&
      (searchData?.TransDate === "" || (val?.TransDate && val?.TransDate?.toLocaleLowerCase().includes(searchData?.TransDate?.toLocaleLowerCase()))) &&
      (searchData?.OpeningBalance === "" || (val?.OpeningBalance && val?.OpeningBalance?.toString().includes(searchData?.OpeningBalance))) &&
      (searchData?.Amount === "" || (val?.Amount && val?.Amount?.toString().includes(searchData?.Amount))) &&
      (searchData?.ClosingBalance === "" || (val?.ClosingBalance && val?.ClosingBalance?.toString().includes(searchData?.ClosingBalance)))
    );
    setTableData(fiterData);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [searchData]);
  const handleSearchData = (event, field) => {
    let value = event.target.value.toString(); // Convert value to string
    setSearchData({ ...searchData, [field]: value });
  }
  const printClick = (isSave) => {
    let columnDef = columns?.filter((item) => item.isSelected)
    const widthCell = calculateTotalTableWidth(columnDef)
    setShowTable(false)
    setState({ ...state, load: true, generatePDF: true })
    jsPDF.API.events.push(['addFonts', callAddFontRobotoBold])
    jsPDF.API.events.push(['addFonts', callAddFontRobotoMedium])

    const pdfColumns = columnDef?.map((col) => {
      return { header: col.exportHead, dataKey: col.field, xlCol: col.xlCol }
    })
    const HeaderColumns = excelHeaderColumn.map((col) => {
      return { header: col.exportHead, dataKey: col.field, xlCol: col.xlCol }
    })
    const HeaderData = [
      {
        company: company,
        state: StateName,
        city: city,
        party: party,
      },
    ]
    // bodyData for credit trans report
    const bodyData = tableData?.map((item, index) =>
      item.isTotal
        ? item
        : {
          sno: index + 1,
          Party: selectedFields.hasOwnProperty('Party') ? item.Party : undefined,
          LRNO: item.LRNO,
          FormattedLRNO: item.FormattedLRNO,
          BookingDateTime: item.BookingDateTime,
          SourceCity:
            (selectedFields.hasOwnProperty('SourceCity') ? item.FromStation : undefined) +
            '\n' +
            (selectedFields.hasOwnProperty('SourceCity') ? item.FromBranch : undefined),
          DestinationCity:
            (selectedFields.hasOwnProperty('DestinationCity') ? item.ToStation : undefined) +
            '\n' +
            (selectedFields.hasOwnProperty('DestinationCity') ? item.ToBranch : undefined),
          ConsignmentType: selectedFields.hasOwnProperty('ConsignmentType') ? item.ConsType : undefined,
          Collection: item.Collection,
          CartageAmount: item.CartageAmount,
          Commission: item.Commission,
          TranType: item.TranType,
          TransDate:
            (item.TranDate !== '' ? moment(item.TranDate).format('DD-MMM-YY') : '') +
            '\n' +
            (item.TranDate !== '' ? new Date(item.TranDate).toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' }) : ''),
          OpeningBalance: item.OpeningBalance,
          Amount: item.Amount,
          ClosingBalance: item.ClosingBalance,
        }
    )
    const doc = new jsPDF({
      orientation: columnDef.length > 12 ? 'l' : 'p',
      format:
        columnDef.length > 12
          ? calculateDynamicFormatLandscape((widthCell > 1122 ? widthCell : 1122) + 60)
          : calculateDynamicFormatPortrait((widthCell > 900 ? widthCell : 900) + 60),
      unit: 'px',
      compress: true,
    })
    var totalPagesExp = '{total_pages_count_string}'
    doc.setProperties({
      title: `Party Credit Limit Transaction Reports.pdf`,
      subject: 'Party Credit Limit Transaction Report',
      author: 'Maven Tech Labs Pvt. Ltd.',
      keywords: 'maven tech, Cargo system, Receive',
      creator: 'MTLPL',
    })
    autoTable(doc, {
      margin: { top: 60, left: 30, right: 30, bottom: 5 },
      alternateRowStyles: {
        fillColor: [255, 255, 255],
      },
      columns: HeaderColumns,
      body: HeaderData,
      columnStyles: {
        0: {
          fontSize: 18,
          valign: 'middle',
          font: 'Roboto',
          fontStyle: 'normal',
          cellPadding: 12,
          minCellHeight: 36,
          halign: 'left',
          textColor: [0, 0, 0],
        },
        1: {
          fontSize: 18,
          valign: 'middle',
          font: 'Roboto',
          fontStyle: 'normal',
          cellPadding: 12,
          minCellHeight: 36,
          halign: 'left',
          textColor: [0, 0, 0],
        },
        2: {
          fontSize: 18,
          valign: 'middle',
          font: 'Roboto',
          fontStyle: 'normal',
          cellPadding: 12,
          minCellHeight: 36,
          halign: 'left',
          textColor: [0, 0, 0],
        },
        3: {
          fontSize: 18,
          valign: 'middle',
          font: 'Roboto',
          fontStyle: 'normal',
          cellPadding: 12,
          minCellHeight: 36,
          halign: 'left',
          textColor: [0, 0, 0],
        },
      },
      theme: 'grid',
      startY: 160,
      headStyles: {
        fillColor: [191, 225, 255],
        textColor: [0, 0, 0],
        minCellHeight: 36,
        valign: 'middle',
        cellPadding: 12,
        fontSize: 18,
        font: 'Roboto',
        fontStyle: 'normal',
        lineWidth: 0.6,
      },
      didDrawPage: function (data) {
        doc.setTextColor(0, 0, 0)
        doc.setFontSize(18).setFont('Roboto', 'bold')
        doc.text(
          `Booking Date: ${moment(fromDate).format('DD-MMM-YYYY')}  To  ${moment(toDate).format('DD-MMM-YYYY')} `,
          data.settings.margin.left,
          150
        )
      },
    })
    //make pdf column style dynamic due to manage column
    const pdfColumnStyles = {}
    columnDef?.forEach((col, index) => {
      const alignment =
        col.id === 0 ||
          col.id === 1 ||
          col.id === 2 ||
          col.id === 3 ||
          col.id === 4 ||
          col.id === 5 ||
          col.id === 6 ||
          col.id === 10 ||
          col.id === 11
          ? 'left'
          : 'right'
      pdfColumnStyles[index] = {
        halign: alignment,
        minCellHeight: 36,
        fontSize: 16,
        cellPadding: 6,
        valign: 'middle',
        fontStyle: 'normal',
        font: 'Roboto',
        textColor: [0, 0, 0],
      }
    })
    autoTable(doc, {
      margin: { top: 120, left: 30, right: 30, bottom: 40 },
      alternateRowStyles: {
        fillColor: [255, 255, 255],
      },
      headStyles: {
        fillColor: [191, 225, 255],
        fontSize: 16,
        minCellHeight: 36,
        cellPadding: 6,
        valign: 'middle',
        fontStyle: 'normal',
        font: 'Roboto',
        textColor: [0, 0, 0],
      },
      tableLineWidth: 0.6,
      columns: pdfColumns,
      body: bodyData,
      styles: {
        lineWidth: [0, 0.2, 0, 0.2],
      },
      columnStyles: pdfColumnStyles,
      theme: 'grid',
      didParseCell: (data) => {
        crdeitDrawCellDetail(data)
      },
      didDrawPage: function (data) {
        doc.setTextColor(40)
        doc.addImage('/images/logo-66.png', 'JPEG', 30, 50, 50, 50)
        doc.setFontSize(26).setFont('Roboto', 'bold')
        doc.setTextColor(16, 79, 162)
        doc.text('Cargo System | Party Credit Limit Transaction Report', 30 + 60, 80)
        doc.setTextColor(0, 0, 0)
        doc.setFontSize(22).setFont('Roboto', 'bold')
        doc.text(`Company Name :${loginData.strCompanyName}`, doc.internal.pageSize.width - data.settings.margin.left, 80, 'right')
        lrDetailPdfFooter(data, loginData, totalPagesExp)
      },
      // showHead: 'never',
    })
    doc.setFont('Roboto')

    if (typeof doc.putTotalPages === 'function') {
      doc.putTotalPages(totalPagesExp)
    }
    if (isSave) {
      doc.save(`Party Credit Limit Transaction Report ${currentDateTime}.pdf`)
      setTimeout(() => {
        setState({ ...state, generatePDF: false, load: true })
        const pdfUrl = doc.output('bloburl')
        document.getElementById('creditLimitTransReport').data = pdfUrl
        // document.getElementById('creditLimitTransReport').data = doc.output('datauristring', ' Party Credit Limit Transaction Reports.pdf')
        focusElemnt('backBtn')
      }, 2000)
    } else {
      setTimeout(() => {
        setState({ ...state, generatePDF: false, load: true })
        const pdfUrl = doc.output('bloburl')
        document.getElementById('creditLimitTransReport').data = pdfUrl
        // document.getElementById('creditLimitTransReport').data = doc.output('datauristring', ' Party Credit Limit Transaction Reports.pdf')
        focusElemnt('backBtn')
      }, 2000)
    }
  }
  const InsideRowContent = ({ item, index }) => {
    return (
      <>
        <TableRow style={{ verticalAlign: 'top' }}>
          <>
            <TableCell
              className="reportTD"
              colSpan={1}
              style={{ background: 'F5FAFE', fontSize: '12px', fontWeight: '500', textAlign: 'left' }}
            >
              {index + 1}
            </TableCell>
            {selectedFields.hasOwnProperty('Party') && (
              <TableCell
                className="reportTD"
                colSpan={1}
                style={{ background: 'F5FAFE', fontSize: '12px', fontWeight: '500', textAlign: 'left', whiteSpace: 'nowrap' }}
              >
                {item.Party}
              </TableCell>
            )}
            <TableCell
              className="reportTD"
              colSpan={1}
              style={{ background: 'F5FAFE', fontSize: '12px', fontWeight: '500', textAlign: 'left', whiteSpace: 'nowrap' }}
            >
              {UseFormattedLRinReports !== 2 ? item.LRNO : item.FormattedLRNO}
            </TableCell>
            {
              UseFormattedLRinReports === 3 &&
              <TableCell
                className="reportTD"
                colSpan={1}
                style={{ background: 'F5FAFE', fontSize: '12px', fontWeight: '500', textAlign: 'left', whiteSpace: 'nowrap' }}
              >
                {item.FormattedLRNO}
              </TableCell>
            }
            <TableCell
              className="reportTD"
              colSpan={1}
              style={{ background: 'F5FAFE', fontSize: '12px', fontWeight: '500', textAlign: 'left', whiteSpace: 'pre' }}
            >
              {item.BookingDateTime}
            </TableCell>
            {selectedFields.hasOwnProperty('SourceCity') && (
              <TableCell
                className="reportTD"
                colSpan={1}
                style={{ background: 'F5FAFE', fontSize: '12px', fontWeight: '500', textAlign: 'left', whiteSpace: 'nowrap' }}
              >
                {item.FromStation}
                <br />
                {item.FromBranch}
              </TableCell>
            )}
            {selectedFields.hasOwnProperty('DestinationCity') && (
              <TableCell
                className="reportTD"
                colSpan={1}
                style={{ background: 'F5FAFE', fontSize: '12px', fontWeight: '500', textAlign: 'left', whiteSpace: 'nowrap' }}
              >
                {item.ToStation}
                <br />
                {item.ToBranch}
              </TableCell>
            )}
            {selectedFields.hasOwnProperty('ConsignmentType') && (
              <TableCell
                className="reportTD"
                colSpan={1}
                style={{ background: 'F5FAFE', fontSize: '12px', fontWeight: '500', textAlign: 'left', whiteSpace: 'nowrap' }}
              >
                {item.ConsType}
              </TableCell>
            )}
            <TableCell
              className="reportTD"
              colSpan={1}
              style={{ background: 'F5FAFE', fontSize: '12px', fontWeight: '500', textAlign: 'right', whiteSpace: 'nowrap' }}
            >
              {item.Collection}
            </TableCell>
            {selectedFields.hasOwnProperty('CartageAmount') && (
              <TableCell
                className="reportTD"
                colSpan={1}
                style={{ background: 'F5FAFE', fontSize: '12px', fontWeight: '500', textAlign: 'right', whiteSpace: 'nowrap' }}
              >
                {item.CartageAmount}
              </TableCell>
            )}
            {/* {loginData?.intCompanyID!==406 && */}
            <TableCell
              className="reportTD"
              colSpan={1}
              style={{ background: 'F5FAFE', fontSize: '12px', fontWeight: '500', textAlign: 'right', whiteSpace: 'nowrap' }}
            >
              {item.Commission}
            </TableCell>
            {/* } */}
            {/* {loginData?.intCompanyID===406 &&<TableCell
              className="reportTD"
              colSpan={1}
              style={{ background: 'F5FAFE', fontSize: '12px', fontWeight: '500', textAlign: 'right', whiteSpace: 'nowrap' }}
            >
              {item.FreightComm}
            </TableCell>}
            {loginData?.intCompanyID===406 &&<TableCell
              className="reportTD"
              colSpan={1}
              style={{ background: 'F5FAFE', fontSize: '12px', fontWeight: '500', textAlign: 'right', whiteSpace: 'nowrap' }}
            >
              {item.InsuranceComm}
            </TableCell>}
            {loginData?.intCompanyID===406 &&<TableCell
              className="reportTD"
              colSpan={1}
              style={{ background: 'F5FAFE', fontSize: '12px', fontWeight: '500', textAlign: 'right', whiteSpace: 'nowrap' }}
            >
              {item.CartageComm}
            </TableCell>} */}
            <TableCell
              className="reportTD"
              colSpan={1}
              style={{ background: 'F5FAFE', fontSize: '12px', fontWeight: '500', textAlign: 'left', whiteSpace: 'nowrap' }}
            >
              {item.TranType}
            </TableCell>
            <TableCell
              className="reportTD"
              colSpan={1}
              style={{ background: 'F5FAFE', fontSize: '12px', fontWeight: '500', textAlign: 'left', whiteSpace: 'nowrap' }}
            >
              {item.TranDate !== '' ? moment(item.TranDate).format('DD-MMM-YY') : ''}
              <br />
              {item.TranDate !== '' ? new Date(item.TranDate).toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' }) : ''}
            </TableCell>
            <TableCell
              className="reportTD"
              colSpan={1}
              style={{ background: 'F5FAFE', fontSize: '12px', fontWeight: '500', textAlign: 'right', whiteSpace: 'nowrap' }}
            >
              {item.OpeningBalance}
            </TableCell>
            <TableCell
              className="reportTD"
              colSpan={1}
              style={{ background: 'F5FAFE', fontSize: '12px', fontWeight: '500', textAlign: 'right', whiteSpace: 'nowrap' }}
            >
              {item.Amount}
            </TableCell>
            <TableCell
              className="reportTD"
              colSpan={1}
              style={{ background: 'F5FAFE', fontSize: '12px', fontWeight: '500', textAlign: 'right', whiteSpace: 'nowrap' }}
            >
              {item.ClosingBalance}
            </TableCell>
          </>
        </TableRow>
      </>
    )
  }
  const InsideRowContentForExcel = ({ item, index }) => {
    return (
      <>
        <TableRow style={{ verticalAlign: 'top', fontSize: '16px' }}>
          <>
            <TableCell className="reportTD" colSpan={1} style={{ background: 'F5FAFE', fontWeight: '500', textAlign: 'left' }}>
              {index + 1}
            </TableCell>
            {selectedFields.hasOwnProperty('Party') && (
              <TableCell
                className="reportTD"
                colSpan={1}
                style={{ background: 'F5FAFE', fontWeight: '500', textAlign: 'left', whiteSpace: 'nowrap' }}
              >
                {item.Party}
              </TableCell>
            )}
            <TableCell
              className="reportTD"
              colSpan={1}
              style={{ background: 'F5FAFE', fontWeight: '500', textAlign: 'left', whiteSpace: 'nowrap' }}
            >
              {UseFormattedLRinReports !== 2 ? item.LRNO : item.FormattedLRNO}
            </TableCell>
            {
              UseFormattedLRinReports === 3 &&
              <TableCell
                className="reportTD"
                colSpan={1}
                style={{ background: 'F5FAFE', fontWeight: '500', textAlign: 'left', whiteSpace: 'nowrap' }}
              >
                {item.FormattedLRNO}
              </TableCell>
            }
            <TableCell
              className="reportTD"
              colSpan={1}
              style={{ background: 'F5FAFE', fontWeight: '500', textAlign: 'left', whiteSpace: 'nowrap' }}
            >
              {item.BookingDateTime}
            </TableCell>
            <TableCell
              className="reportTD"
              colSpan={1}
              style={{ background: 'F5FAFE', fontWeight: '500', textAlign: 'left', whiteSpace: 'nowrap' }}
            >
              {item.BookingDateTime !== ''
                ? new Date(item.BookingDateTime).toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' })
                : ''}
            </TableCell>
            {selectedFields.hasOwnProperty('SourceCity') && (
              <TableCell
                className="reportTD"
                colSpan={1}
                style={{ background: 'F5FAFE', fontWeight: '500', textAlign: 'left', whiteSpace: 'nowrap' }}
              >
                {item.FromStation}
              </TableCell>
            )}
            {selectedFields.hasOwnProperty('SourceCity') && (
              <TableCell
                className="reportTD"
                colSpan={1}
                style={{ background: 'F5FAFE', fontWeight: '500', textAlign: 'left', whiteSpace: 'nowrap' }}
              >
                {item.FromBranch}
              </TableCell>
            )}
            {selectedFields.hasOwnProperty('DestinationCity') && (
              <TableCell
                className="reportTD"
                colSpan={1}
                style={{ background: 'F5FAFE', fontWeight: '500', textAlign: 'left', whiteSpace: 'nowrap' }}
              >
                {item.ToStation}
              </TableCell>
            )}
            {selectedFields.hasOwnProperty('DestinationCity') && (
              <TableCell
                className="reportTD"
                colSpan={1}
                style={{ background: 'F5FAFE', fontWeight: '500', textAlign: 'left', whiteSpace: 'nowrap' }}
              >
                {item.ToBranch}
              </TableCell>
            )}
            {selectedFields.hasOwnProperty('ConsignmentType') && (
              <TableCell
                className="reportTD"
                colSpan={1}
                style={{ background: 'F5FAFE', fontWeight: '500', textAlign: 'left', whiteSpace: 'nowrap' }}
              >
                {item.ConsType}
              </TableCell>
            )}
            <TableCell
              className="reportTD"
              colSpan={1}
              style={{ background: 'F5FAFE', fontWeight: '500', textAlign: 'right', whiteSpace: 'nowrap' }}
            >
              {item.Collection}
            </TableCell>
            {selectedFields.hasOwnProperty('CartageAmount') && (
              <TableCell
                className="reportTD"
                colSpan={1}
                style={{ background: 'F5FAFE', fontWeight: '500', textAlign: 'right', whiteSpace: 'nowrap' }}
              >
                {item.CartageAmount}
              </TableCell>
            )}
            <TableCell
              className="reportTD"
              colSpan={1}
              style={{ background: 'F5FAFE', fontWeight: '500', textAlign: 'right', whiteSpace: 'nowrap' }}
            >
              {item.Commission}
            </TableCell>
            {/* <TableCell
              className="reportTD"
              colSpan={1}
              style={{ background: 'F5FAFE', fontWeight: '500', textAlign: 'right', whiteSpace: 'nowrap' }}
            >
              {item.FreightComm}
            </TableCell>
            <TableCell
              className="reportTD"
              colSpan={1}
              style={{ background: 'F5FAFE', fontWeight: '500', textAlign: 'right', whiteSpace: 'nowrap' }}
            >
              {item.InsuranceComm}
            </TableCell>
            <TableCell
              className="reportTD"
              colSpan={1}
              style={{ background: 'F5FAFE', fontWeight: '500', textAlign: 'right', whiteSpace: 'nowrap' }}
            >
              {item.CartageComm}
            </TableCell> */}
            <TableCell
              className="reportTD"
              colSpan={1}
              style={{ background: 'F5FAFE', fontWeight: '500', textAlign: 'left', whiteSpace: 'nowrap' }}
            >
              {item.TranType}
            </TableCell>
            <TableCell
              className="reportTD"
              colSpan={1}
              style={{ background: 'F5FAFE', fontWeight: '500', textAlign: 'left', whiteSpace: 'nowrap' }}
            >
              {item.TranDate !== '' ? moment(item.TranDate).format('DD-MMM-YY') : ''}
            </TableCell>
            <TableCell
              className="reportTD"
              colSpan={1}
              style={{ background: 'F5FAFE', fontWeight: '500', textAlign: 'left', whiteSpace: 'nowrap' }}
            >
              {item.TranDate !== '' ? new Date(item.TranDate).toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' }) : ''}
            </TableCell>
            <TableCell
              className="reportTD"
              colSpan={1}
              style={{ background: 'F5FAFE', fontWeight: '500', textAlign: 'right', whiteSpace: 'nowrap' }}
            >
              {item.OpeningBalance}
            </TableCell>
            <TableCell
              className="reportTD"
              colSpan={1}
              style={{ background: 'F5FAFE', fontWeight: '500', textAlign: 'right', whiteSpace: 'nowrap' }}
            >
              {item.Amount}
            </TableCell>
            <TableCell
              className="reportTD"
              colSpan={1}
              style={{ background: 'F5FAFE', fontWeight: '500', textAlign: 'right', whiteSpace: 'nowrap' }}
            >
              {item.ClosingBalance}
            </TableCell>
          </>
        </TableRow>
      </>
    )
  }
  return (
    <>
      <Box className="userReport" style={{ display: 'flex', width: '100%', height: '40px', padding: '12px 0px', marginRight: '0px' }}>
        <Box style={{ display: 'flex', width: '50%', justifyContent: 'flex-start', alignItems: 'center', gap: '12px', fontSize: '14px' }}>
          <h3 style={{ textAlign: 'left', color: '#444', paddingLeft: '16px' }}>Report For: Party Credit Limit Transaction Report</h3>
          <Box
            style={{
              height: '32px',
              display: 'flex',
              padding: '18px',
              justifycontent: 'center',
              alignitems: 'center',
              gap: '6px',
            }}
            id="dispatchReportManageColumn"
            tabIndex={0}
            onClick={() => updateModal(true, 'showManageColumnForCreditTrans')}
          >
            <span tabIndex={0} style={{ display: 'flex', margin: '-3px' }}>
              <AppsIcon />
            </span>
            <span tabIndex={0} style={{ fontWeight: 'bold' }}>
              MANAGE COLUMNS
            </span>
          </Box>
        </Box>
        <Box
          className="userReport-buttons"
          style={{
            display: 'flex',
            width: '50%',
            justifyContent: 'end',
            alignItems: 'center',
            paddingRight: '16px',
          }}
        >
          {showTable ? (
            <>
              <Box onKeyDown={(e) => navigation3(e, 'creditTransPdfBtn', id.creditTransSplitButton, () => { })}>
                <ReactHtmlTableToExcel
                  id="creditTransExcelBtn"
                  className="userWisereporttemExcelBtn"
                  table="table-to-xls1"
                  filename={`Party Credit Limit Transaction Report ${currentDateTime}`}
                  sheet="tablexls"
                  buttonText="Export to Excel"
                />
              </Box>
              <Box>
                <Button
                  id="creditTransPdfBtn"
                  onKeyDown={(e) =>
                    navigation3(e, 'creditTransPrintBtn', 'creditTransExcelBtn', () => {
                      printClick(true)
                    })
                  }
                  variant="outlined"
                  className="userWisereporttembtn"
                  onClick={() => printClick(true)}
                >
                  Export to Pdf
                </Button>
              </Box>
              <Box>
                <Button
                  id="creditTransPrintBtn"
                  variant="outlined"
                  className="userWisereporttembtn"
                  onClick={() => printClick(false)}
                  onKeyDown={(e) =>
                    navigation3(e, id.creditTransFromDate, 'creditTransPdfBtn', () => {
                      printClick(false)
                    })
                  }
                >
                  Print
                </Button>
              </Box>
            </>
          ) : (
            <>
              <Box>
                <Button
                  id="backBtn"
                  variant="outlined"
                  className="userWisereporttembtn"
                  onClick={() => (setShowTable(true), updateScreen())}
                >
                  Back
                </Button>
              </Box>
            </>
          )}
        </Box>
      </Box>
      {showTable ? (
        <>
          <Stack
            sx={{ marginLeft: 2, marginRight: 2, height: 440, paddingTop: '10px', marginBottom: '16px' }}
            className="changeScrollColor"
          >
            <TableContainer className="scroll" style={{ borderRadius: '6px', border: '1px solid rgb(224 224 224)' }}>
              {/* ---------------Table For Excel--------------- */}
              <Table id="table-to-xls1" className="table1 table-Report" size="small" aria-label="a dense table" style={{ display: 'none' }}>
                <TableHead style={{ fontWeight: 'bold', position: 'sticky', top: '0' }}>
                  {/* -------TableHeader--------- */}
                  <TableRow style={{ fontSize: '18px', fontWeight: '500', textAlign: 'left' }}>
                    <TableCell className="reportTD" style={{textAlign: 'left' }} colSpan={UseFormattedLRinReports === 3?8:7}>
                      Report For: Party Credit Limit Transaction Report
                    </TableCell>
                    <TableCell className="reportTD" colSpan={8}>
                      Company Name : {loginData.strCompanyName}
                    </TableCell>
                  </TableRow>
                  <TableRow>
                    <TableCell colSpan={UseFormattedLRinReports === 3?16:15}></TableCell>
                  </TableRow>
                  <TableRow style={{ color: 'white' }}>
                    {excelHeaderCreditReport?.map((item, i) => (
                      <TableCell
                        className="ReportItemHead"
                        style={{ backgroundColor: '#e5f3ff', color: '#444', fontSize: '16px', fontWeight: '500', textAlign: 'left' }}
                        colSpan={item.col}
                        key={i}
                      >
                        {item.value}
                      </TableCell>
                    ))}
                  </TableRow>
                  <TableRow style={{ fontSize: '16px', textAlign: 'left' }}>
                    <TableCell className="reportTD" colSpan={3} style={{ textAlign: 'left', fontWeight: '200' }}>
                      <span>{company}</span>
                    </TableCell>
                    <TableCell className="reportTD" colSpan={2} style={{ textAlign: 'left', fontWeight: '200' }}>
                      <span>{moment(fromDate).format('DD/MM/YYYY')}</span>
                    </TableCell>
                    <TableCell className="reportTD" colSpan={2} style={{ textAlign: 'left', fontWeight: '200' }}>
                      <span>{moment(toDate).format('DD/MM/YYYY')}</span>
                    </TableCell>
                    <TableCell className="reportTD" colSpan={3} style={{ textAlign: 'left', fontWeight: '200' }}>
                      <span>{StateName}</span>
                    </TableCell>
                    <TableCell className="reportTD" colSpan={3} style={{ textAlign: 'left', fontWeight: '200' }}>
                      <span>{city}</span>
                    </TableCell>
                    <TableCell className="reportTD" colSpan={3} style={{ textAlign: 'left', fontWeight: '200' }}>
                      <span>{party}</span>
                    </TableCell>
                  </TableRow>
                  <TableRow>
                    <TableCell colSpan={UseFormattedLRinReports === 3?16:15}></TableCell>
                  </TableRow>
                  <TableRow
                    style={{
                      fontSize: '16px',
                      verticalAlign: 'top',
                    }}
                  >
                    <TableCell className="ReportItemHead" style={{ backgroundColor: '#bfe1ff', color: '#444', fontSize: '16px', fontWeight: '500', textAlign: 'left', whiteSpace: 'nowrap' }} colSpan={1}>SN</TableCell>
                    {selectedFields.hasOwnProperty('Party') && <TableCell className="ReportItemHead" style={{ backgroundColor: '#bfe1ff', color: '#444', fontSize: '16px', fontWeight: '500', textAlign: 'left', whiteSpace: 'nowrap' }} colSpan={1}>Party Name</TableCell>}
                    <TableCell className="ReportItemHead" style={{ backgroundColor: '#bfe1ff', color: '#444', fontSize: '16px', fontWeight: '500', textAlign: 'left', whiteSpace: 'nowrap' }} colSpan={1}>{UseFormattedLRinReports !== 2 ? 'LR No.' : 'Formatted LRNO'}</TableCell>
                    {
                      UseFormattedLRinReports === 3 &&
                      <TableCell className="ReportItemHead" style={{ backgroundColor: '#bfe1ff', color: '#444', fontSize: '16px', fontWeight: '500', textAlign: 'left', whiteSpace: 'nowrap' }} colSpan={1}>Formatted LRNO</TableCell>
                    }
                    <TableCell className="ReportItemHead" style={{ backgroundColor: '#bfe1ff', color: '#444', fontWeight: '500', textAlign: 'left', whiteSpace: 'nowrap' }} colSpan={1}>Bkg.Date</TableCell>
                    <TableCell className="ReportItemHead" style={{ backgroundColor: '#bfe1ff', color: '#444', fontWeight: '500', textAlign: 'left', whiteSpace: 'nowrap' }} colSpan={1}>Bkg.Time</TableCell>
                    {selectedFields.hasOwnProperty('SourceCity') && <TableCell className="ReportItemHead" style={{ backgroundColor: '#bfe1ff', color: '#444', fontWeight: '500', textAlign: 'left', whiteSpace: 'nowrap' }} colSpan={1}>Src City</TableCell>}
                    {selectedFields.hasOwnProperty('SourceCity') && <TableCell className="ReportItemHead" style={{ backgroundColor: '#bfe1ff', color: '#444', fontWeight: '500', textAlign: 'left', whiteSpace: 'nowrap' }} colSpan={1}>Src Branch</TableCell>}
                    {selectedFields.hasOwnProperty('DestinationCity') && <TableCell className="ReportItemHead" style={{ backgroundColor: '#bfe1ff', color: '#444', fontWeight: '500', textAlign: 'left', whiteSpace: 'nowrap' }} colSpan={1}>Dest.City</TableCell>}
                    {selectedFields.hasOwnProperty('DestinationCity') && <TableCell className="ReportItemHead" style={{ backgroundColor: '#bfe1ff', color: '#444', fontWeight: '500', textAlign: 'left', whiteSpace: 'nowrap' }} colSpan={1}>Dest.Branch</TableCell>}
                    {selectedFields.hasOwnProperty('ConsignmentType') && <TableCell className="ReportItemHead" style={{ backgroundColor: '#bfe1ff', color: '#444', fontWeight: '500', textAlign: 'left', whiteSpace: 'nowrap' }} colSpan={1}>Consignment</TableCell>}
                    <TableCell className="ReportItemHead" style={{ backgroundColor: '#bfe1ff', color: '#444', fontWeight: '500', textAlign: 'right', whiteSpace: 'nowrap' }} colSpan={1}>Collection</TableCell>
                    {selectedFields.hasOwnProperty('CartageAmount') && <TableCell className="ReportItemHead" style={{ backgroundColor: '#bfe1ff', color: '#444', fontWeight: '500', textAlign: 'left', whiteSpace: 'nowrap' }} colSpan={1}>Cartage</TableCell>}
                    <TableCell className="ReportItemHead" style={{ backgroundColor: '#bfe1ff', color: '#444', fontWeight: '500', textAlign: 'right', whiteSpace: 'nowrap' }} colSpan={1}>Commission</TableCell>
                    {/* {loginData?.intCompanyID===406 && <TableCell className="ReportItemHead" style={{ backgroundColor: '#bfe1ff', color: '#444', fontWeight: '500', textAlign: 'right', whiteSpace: 'nowrap' }} colSpan={1}>Freight Comm.</TableCell>}
                    {loginData?.intCompanyID===406 && <TableCell className="ReportItemHead" style={{ backgroundColor: '#bfe1ff', color: '#444', fontWeight: '500', textAlign: 'right', whiteSpace: 'nowrap' }} colSpan={1}>Valuation Comm.	</TableCell>}
                    {loginData?.intCompanyID===406 && <TableCell className="ReportItemHead" style={{ backgroundColor: '#bfe1ff', color: '#444', fontWeight: '500', textAlign: 'right', whiteSpace: 'nowrap' }} colSpan={1}>Cartage Comm.</TableCell>} */}
                    <TableCell className="ReportItemHead" style={{ backgroundColor: '#bfe1ff', color: '#444', fontWeight: '500', textAlign: 'left', whiteSpace: 'nowrap' }} colSpan={1}>Transaction</TableCell>
                    <TableCell className="ReportItemHead" style={{ backgroundColor: '#bfe1ff', color: '#444', fontWeight: '500', textAlign: 'left', whiteSpace: 'nowrap' }} colSpan={1}>Txn.Date</TableCell>
                    <TableCell className="ReportItemHead" style={{ backgroundColor: '#bfe1ff', color: '#444', fontWeight: '500', textAlign: 'left', whiteSpace: 'nowrap' }} colSpan={1}>Txn.Time</TableCell>
                    <TableCell className="ReportItemHead" style={{ backgroundColor: '#bfe1ff', color: '#444', fontWeight: '500', textAlign: 'right', whiteSpace: 'nowrap' }} colSpan={1}>Opening<br />Balance</TableCell>
                    <TableCell className="ReportItemHead" style={{ backgroundColor: '#bfe1ff', color: '#444', fontWeight: '500', textAlign: 'right', whiteSpace: 'nowrap' }} colSpan={1}>Transaction<br />Amount</TableCell>
                    <TableCell className="ReportItemHead" style={{ backgroundColor: '#bfe1ff', color: '#444', fontWeight: '500', textAlign: 'right', whiteSpace: 'nowrap' }} colSpan={1}>Closing<br />Balance</TableCell>
                  </TableRow>
                </TableHead>
                {tableData?.length < 1 ? (
                  <>
                    <TableBody>
                      <TableRow>
                        <TableCell colSpan={10}>
                          <div
                            style={{
                              display: 'flex',
                              justifyContent: 'center',
                              marginTop: '20px',
                              marginBottom: '20px',
                              color: 'red',
                              fontSize: '12px',
                              lineheight: '16px',
                              letterspacing: '0.24px',
                            }}
                          >
                            <span>No results found. Please refine your search parameters and search again.</span>
                          </div>
                        </TableCell>
                      </TableRow>
                    </TableBody>
                  </>
                ) : tableData?.length >= 1 ? (
                  <TableBody
                    className="filter-data-row"
                    style={{
                      textAlign: 'center',
                      fontSize: '12px',
                      lineheight: '16px',
                      letterspacing: '0.24px',
                      fontWeight: '500',
                      marginLeft: '5px',
                    }}
                  >
                    {tableData?.map((item, index) => (
                      <InsideRowContentForExcel item={item} index={index} key={index} />
                    ))}
                  </TableBody>
                ) : (
                  ''
                )}
              </Table>
              <Table id="table-to-xls" className="table1 table-Report" size="small" aria-label="a dense table" stickyHeader>
                <TableHead style={{ fontWeight: 'bold', position: 'sticky', top: '0' }}>
                  {/* -------TableHeader--------- */}
                  <TableRow
                    style={{
                      backgroundColor: '#bfe1ff',
                      verticalAlign: 'top',
                    }}
                  >
                    {columns
                      ?.filter((item) => item.isSelected)
                      .map((item, index) => (
                        <TableCell
                          className="ReportItemHead"
                          style={{
                            backgroundColor: '#bfe1ff',
                            color: '#444',
                            fontSize: '12px',
                            fontWeight: '500',
                            // textAlign: index < 9 ? 'left' : 'right',
                            textAlign:item.headerSx.textAlign,
                            whiteSpace: 'pre',
                          }}
                          colSpan={1}
                        >
                          {item.exportHead}
                        </TableCell>
                      ))}
                  </TableRow>
                  <TableRow sx={{ '& .MuiTableCell-root': { padding: '6px !important', backgroundColor: '#fff' } }}>
                    {columns.map((col, index) => {
                      // Check if selectedFields has the col.field
                      const isFieldSelected = selectedFields?.hasOwnProperty(col.field);

                      // If the field is not selected, return null (no cell will be rendered)
                      if (!isFieldSelected) {
                        return null; // Skip rendering this cell
                      }

                      return (
                        <TableCell key={`FTH-${index}`}>
                          {col.showFilter ? (
                            <div className="filter-input" style={{ fontSize: '12px', justifyContent: 'space-between', zIndex: 3 }}>
                              <input
                                id={`Contains-${index}`}
                                className="field"
                                value={searchData[col.field] || ''} // Ensure value is defined
                                name="cancelSearchInput"
                                style={{ width: '100%' }}
                                placeholder="Contains"
                                onChange={(e) => handleSearchData(e, col.field)}
                              />
                              <FilterAltIcon sx={{ paddingRight: '0px !important', color: '#aaa !important' }} />
                            </div>
                          ) : (
                            // If showFilter is false, render an empty cell
                            <span></span>
                          )}
                        </TableCell>
                      );
                    })}
                  </TableRow>
                </TableHead>
                {tableData?.length < 1 ? (
                  <>
                    <TableBody>
                      <TableRow>
                        <TableCell colSpan={15}>
                          <div
                            style={{
                              display: 'flex',
                              justifyContent: 'center',
                              marginTop: '20px',
                              marginBottom: '20px',
                              color: 'red',
                              fontSize: '12px',
                              lineheight: '16px',
                              letterspacing: '0.24px',
                            }}
                          >
                            <span>No results found. Please refine your search parameters and search again.</span>
                          </div>
                        </TableCell>
                      </TableRow>
                    </TableBody>
                  </>
                ) : tableData?.length >= 1 ? (
                  <TableBody
                    className="filter-data-row"
                    style={{
                      textAlign: 'center',
                      fontSize: '12px',
                      lineheight: '16px',
                      letterspacing: '0.24px',
                      fontWeight: '500',
                      marginLeft: '5px',
                    }}
                  >
                    {tableData?.map((item, index) => (
                      <InsideRowContent item={item} index={index} key={index} />
                    ))}
                  </TableBody>
                ) : (
                  ''
                )}
              </Table>
            </TableContainer>
          </Stack>
        </>
      ) : (
        <>
          {generatePDF ? <div className={'generatePDF'}>Generating PDF....</div> : ''}
          {load ? (
            <object
              id="creditLimitTransReport"
              type="application/pdf"
              width={'100%'}
              height="440"
              title="MTLPL -Cargo System - After Transfer Summary Report"
              aria-label="MTLPL -Cargo System - After Transfer Summary Report"
              style={{ marginTop: '10px' }}
            ></object>
          ) : (
            ''
          )}
        </>
      )}
    </>
  )
}
export default TablePartywiseCreditLimitTransactionReport
